export default __webpack_public_path__ + "static/media/group-11@3x.66595da5.webp";